import { HttpResponse } from '@angular/common/http';
import {
  ChangeDetectorRef,
  Component, inject, Input, OnChanges, OnInit,
  signal,
  viewChildren,
} from '@angular/core';
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox';

import { WorkUserSpecialitiesService } from '../../admin/services/work-user-specialities.service';
import { RequirementsService } from '../../services/requirements.service';
import { Requirement } from '../../models/requirement.model';

@Component({
    selector: 'app-work-user-speciality',
    templateUrl: './work-user-speciality.component.html',
    styleUrls: ['./work-user-speciality.component.scss'],
    standalone: false
})
export class WorkUserSpecialityComponent implements OnInit {
  requirements = signal<Requirement[]>([]);

  specialities:any = null;

  @Input() user: any;

  checkboxes = viewChildren(MatCheckbox)

  private readonly cdr = inject(ChangeDetectorRef);

  constructor(
    private requirementService: RequirementsService,
    private service: WorkUserSpecialitiesService,
  ) { }

  ngOnInit() {
    this.requirementService.all().toPromise().then((value:HttpResponse<any[]>) => {
      this.requirements.set(value.body);
    });

    if (this.user) {
      this.specialities = this.user.work_user_specialities;
    }
  }

  getValue(type, id) {
    const found = this.specialities.find((s) => s.speciality_type === type && s.speciality_id === id);
    if (found) {
      return found.enable;
    }
    return false;
  }

  setValue(type, id, event: MatCheckboxChange) {
    this.service.create({
      speciality_type: type,
      speciality_id: id,
      enable: event.checked,
      user_id: this.user.id,
    }).toPromise().catch((error) => {
      console.log(error);
    });
  }

  toggleAll(value) {
    if (!value.checked) {
      this.uncheckAll();
    } else {
      this.checkAll();
    }

    this.cdr.detectChanges();
  }

  private uncheckAll() {
    this.requirements().forEach((r) => {
      this.setValue('Requirement', r.id, { checked: false, source: null });
    });
    this.checkboxes().forEach((checkbox: MatCheckbox) => {
      checkbox.checked = false;
    });
  }

  private checkAll() {
    this.requirements().forEach((r) => {
      this.setValue('Requirement', r.id, { checked: true, source: null });
    });
    this.checkboxes().forEach((checkbox: MatCheckbox) => {
      checkbox.checked = true;
    });
  }
}
